/**
 * Shared constants — single source of truth.
 * Import from here instead of hardcoding values.
 */

export const LOGO_URL = process.env.REACT_APP_FIRM_LOGO_URL || "/bonsai-logo.png";

export const APP_NAME = "Bonsai CaseMinder";

/**
 * White-label firm name. Mirrors the backend's FIRM_NAME env resolution
 * (hub/ccl_ai_sweep.py::_resolve_firm_name) so no firm string is ever
 * hardcoded in the frontend. Falls back to a neutral label.
 */
export const FIRM_NAME = process.env.REACT_APP_FIRM_NAME || "the firm";

/**
 * Koi background — used on all client-facing portal pages.
 * Fixed, full-cover, behind everything at low opacity.
 */
export const KOI_BG_URL = process.env.REACT_APP_KOI_BG_URL || "/koi-bg.png"; // BM-H3509: the shipped file is .png; .jpg 404ed

/**
 * Practice areas — the live values used by Bonsai Law.
 * Must match the backend validation in routes_conflicts.py
 * (ACTIVE_PRACTICE_AREA_CODES, derived from matter_type_taxonomy.py).
 * Codes 04/05 are retired; 07 IP aligns with the SharePoint "07." folder.
 * 08 Private Client covers Wills, LPAs, Combined Wills+LPA, and Estate
 * Planning Review — added post-BM-wire-client-guides (commit a293474) once
 * the private-client welcome pack and CCL resolver went live.
 */
export const PRACTICE_AREAS = [
  { value: "01 RESI", label: "Residential" },
  { value: "02 COCO", label: "Company & Commercial" },
  { value: "03 Commercial Property", label: "Commercial Property" },
  { value: "06 COCO Disputes", label: "COCO Disputes" },
  { value: "07 IP", label: "Intellectual Property" },
  { value: "08 Private Client", label: "Private Client (Wills & LPA)" },
];
